// utils/dateFormatter.js

/**
 * تحويل التاريخ من صيغة خاطئة إلى yyyy-mm-dd
 * @param {string} dateString - التاريخ المراد تحويله
 * @returns {string} - التاريخ بصيغة صحيحة yyyy-mm-dd
 */
export const formatDate = (dateString) => {
  if (!dateString) return "";

  // إذا كان التاريخ بصيغة ISO (مثل "2026-01-10T09:00:25.000Z")
  if (dateString.includes("T")) {
    return dateString.split("T")[0]; // ارجع yyyy-mm-dd فقط
  }

  // إذا كان التاريخ بصيغة خاطئة yyyy-dd-mm، حوله إلى yyyy-mm-dd
  const parts = dateString.split("-");
  if (parts.length === 3) {
    const [year, day, month] = parts;
    // تحقق إذا كان الـ day و month معكوسين
    if (parseInt(day) > 12) {
      return `${year}-${day}-${month}`; // هو بالفعل صحيح
    }
    // إذا كان month > 12، فالترتيب خاطئ
    if (parseInt(month) > 12) {
      return `${year}-${month}-${day}`;
    }
  }

  return dateString;
};

/**
 * تحويل التاريخ إلى صيغة عربية مقروءة (من اليمين للشمال) بأرقام إنجليزية
 * @param {string} dateString - التاريخ المراد تحويله
 * @returns {string} - التاريخ بصيغة عربية
 */
export const formatDateArabic = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  // التحقق من صحة التاريخ
  if (isNaN(date.getTime())) return "";

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  // استخدام en-US بدل ar-SA عشان الأرقام تكون إنجليزية
  return date.toLocaleDateString("ar-SA-u-nu-latn", options);
};

/**
 * تنسيق التاريخ بالأرقام (يوم/شهر/سنة) - من اليمين لليسار
 * @param {string} dateString - التاريخ المراد تحويله
 * @returns {string} - التاريخ بالأرقام الإنجليزية
 */
export const formatDateNumbers = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${year}/${month}/${day}`;
};
